import { useState } from 'react';
import {
  Box, Typography, Paper,
} from '@mui/material';
import { ListPageHeader } from '@/components/ListPageHeader';
import { DomainTree } from '@/components/domain-engine/DomainTree';
import { DomainInfoPanel } from '@/components/domain-engine/DomainInfoPanel';

export const DomainList = () => {
  const [selectedDomainId, setSelectedDomainId] = useState<string | null>(null);

  return (
    <Box sx={{ p: 3 }}>
      <ListPageHeader
        title="Domain Registry"
        metrics={[]}
      />
      <Box sx={{ display: 'flex', gap: 3, mt: 3, height: 'calc(100vh - 200px)', minHeight: 500 }}>
        {/* Left Panel — Domain Tree */}
        <Paper
          elevation={0}
          sx={{
            width: '38%',
            minWidth: 320,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Typography variant="subtitle2" color="text.secondary">
              Select a domain to view details
            </Typography>
          </Box>
          <Box sx={{ flex: 1, overflow: 'auto', p: 1 }}>
            <DomainTree
              selected={selectedDomainId ?? undefined}
              onSelect={setSelectedDomainId}
            />
          </Box>
        </Paper>

        {/* Right Panel — Domain Details */}
        <Box sx={{ flex: 1, overflow: 'auto' }}>
          {selectedDomainId ? (
            <DomainInfoPanel domainId={selectedDomainId} />
          ) : (
            <Paper
              elevation={0}
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
              }}
            >
              <Box sx={{ textAlign: 'center', color: 'text.disabled' }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  No domain selected
                </Typography>
                <Typography variant="body2">
                  Select a domain from the tree to view its details and tenant access.
                </Typography>
              </Box>
            </Paper>
          )}
        </Box>
      </Box>
    </Box>
  );
};
